@if (profileField$ | async; as profileField) {
    <sh-form-typed-value-list
        [control]="control$ | async"
        [label]="typeLabel$ | async"
        [labelIcons]="labelIcons"
        [types]="options$ | async"
        [id]="profileField.FieldDefinition.FlatKey"
        [errorMsg]="(errorMsg$ | async) || '' | translate"
        [helpText]="profileField.Description"
        [canBeIndeterminate]="canBeIndeterminate"
        [indeterminateMsg]="'general.only-matching-values-shown' | translate"
        [title]="disabledMessageKey | translate"
        [autocompleteFcts]="subFieldAutocompleteFcts"
    >
        <ng-content></ng-content>
    </sh-form-typed-value-list>
}
